import { Link } from "react-router-dom";
import _ from "lodash";
import { format, parseISO } from "date-fns";
import { useEffect, useState, useRef, useCallback } from "react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const formatDate = (dateTimeString) => {
  const dateObj = new Date(dateTimeString);
  const day = dateObj.toLocaleDateString("en-US", { weekday: "short" });
  const month = dateObj.toLocaleDateString("en-US", { month: "long" });
  const dateNumber = dateObj.getDate();
  const year = dateObj.getFullYear();
  const time = dateObj.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
  });

  return `${month} ${dateNumber} • ${time}`;
};

const getTimeNumber = (dateTimeString) => {
  const dateObj = new Date(dateTimeString);
  return dateObj.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
  });
};

const getDayOfWeek = (dateTimeString) => {
  const dateObj = new Date(dateTimeString);
  return dateObj.toLocaleDateString("en-US", { weekday: "short" }).slice(0, 3);
};

const getDateNumber = (dateTimeString) => {
  const dateObj = new Date(dateTimeString);
  return dateObj.getDate();
};

const getMonthName = (dateTimeString) => {
  const dateObj = new Date(dateTimeString);
  return dateObj.toLocaleDateString("en-US", { month: "long" });
};

const getYearName = (dateTimeString) => {
  const dateObj = new Date(dateTimeString);
  return dateObj.toLocaleDateString("en-US", { year: "numeric" });
};

function Meeting({
  instance,
  instanceList,
  customEventDetails,
  duplicates,
  selectedDay,
}) {
  const [isManualResize, setIsManualResize] = useState(false);
  const meetingRef = useRef(null);
  const [resizeKey, setResizeKey] = useState(0);

   const triggerResize = () => {
      if (typeof window.parentIFrame?.size === "function") {
        setTimeout(() => {
          window.parentIFrame.size();
          console.log("Resize triggered", new Date().toLocaleTimeString());
          setResizeKey((prev) => prev + 1); // Force re-render
        }, 300); // Longer delay for dynamic content
      } else {
        console.warn("parentIFrame not available");
      }
    };
  
    useEffect(() => {
      console.log("ParentIFrame available?", !!window.parentIFrame);
    }, []);

  // Save selected day to localStorage whenever it changes
  useEffect(() => {
    if (selectedDay) {
      localStorage.setItem('lastSelectedDay', selectedDay.toISOString());
    }
  }, [selectedDay]);

  // Local link click handler
  const handleLinkClick = (path, eventDate, eventId, eventName) => {
    localStorage.setItem(
      "customEventDetails",
      JSON.stringify(customEventDetails)
    );
    localStorage.setItem("eventDate", eventDate);
    triggerResize();
    window.parent.location.href = path;
  };


  // Filter and process meetings
  const filteredMeetings = customEventDetails.filter(
    (event) => event && event.isOnSale && event.start
  );

  // Sort events by date
  const orderedByDay = filteredMeetings.sort((a, b) => {
    return new Date(a.start) - new Date(b.start);
  });

  // Check sold out status
  function areAllInstancesSoldOutForDay(orderedDay, id, day) {
    const instances = orderedDay.filter(
      (inst) => inst.id === id && inst.start.split("T")[0] === day
    );
    return {
      allSoldOut: instances.every((inst) => inst.availableStatus === 0),
      instancesOnDayAndEventId: instances,
    };
  }

  const { allSoldOut, instancesOnDayAndEventId } = areAllInstancesSoldOutForDay(
    orderedByDay,
    instance.id,
    instance.start.split("T")[0]
  );

  // Utility function to shorten the ID
  const shortenId = (id) => id.substring(0, 5).toLowerCase();

  // Track rendered events
  const duplicateInstanceIds = duplicates.map(inst => inst.instanceId);
  const eventKey = `${instance.instanceId}`;

  if (duplicateInstanceIds.includes(eventKey)) {
    return null;
  }

  return (
    <div
      ref={meetingRef}
      className="pt-2 meeting-container"
      style={{
        background: "#0D0D0D",
        display: "flex",
        justifyContent: "center",
      }}
      data-selected-day={selectedDay?.toISOString()}
      data-event-id={instance?.id}
    >
        <li className="content-center" key={instance.instanceId}>
          <div class="grid place-content-center gap-4 sm:grid-cols-3 md:grid-cols-3">
            <div
              class=""
              style={{
                height: "100%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div class="" style={{ flex: "1", maxWidth: "400px" }}>
                {/* Existing event instance rendering logic */}
                <div className=""></div>
                {instance.attribute_EventCategory && (
                  <div class="pb-2">
                    <div className="pb-2">
                      <a
                        href={
                          instance.attribute_FreeEvent
                            ? `/visit/${instance.id
                                .substring(0, 5)
                                .toLowerCase()}/`
                            : `/event/${instance.id
                                .substring(0, 5)
                                .toLowerCase()}/`
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          handleLinkClick(
                            instance.attribute_FreeEvent
                              ? `/visit/${instance.id
                                  .substring(0, 5)
                                  .toLowerCase()}/`
                              : `/event/${instance.id
                                  .substring(0, 5)
                                  .toLowerCase()}/`,
                            instance.start,
                            instance.id,
                            instance.name
                          );
                        }}
                      >
                        <img
                          src={instance.imageUrl}
                          alt={instance.name}
                          className="object-cover"
                          style={{
                            width: "100%", // Set width to 100%
                            height: "100%", // Set height to 100%
                            objectFit: "cover",
                            objectPosition: "top", // Position the image at the top
                          }}
                        />
                      </a>
                    </div>
                    <p
                      style={{
                        fontFamily: "Montserrat, Poppins, sans-serif",
                        textTransform: "uppercase",
                        fontStyle: "italic",
                      }}
                    >
                      {instance.attribute_EventCategory}
                    </p>
                  </div>
                )}
                <div
                  className=""
                  style={{
                    width: "auto",
                    fontWeight: "lighter", // Apply lighter font weight
                    fontSize: ".8rem", // Adjust font size to make the text smaller
                    fontFamily: "Montserrat, Poppins, sans-serif",
                    textTransform: "uppercase",
                  }}
                >
                  {instanceList[instance.id] && (
                    <p
                      className="pb-2"
                      style={{
                        fontFamily: "Montserrat, Poppins, sans-serif",
                        textTransform: "uppercase",
                        fontStyle: "italic",
                      }}
                    >
                      {/* Render start times for the specific day of the event */}
                      {Object.values(
                        _.groupBy(instanceList[instance.id], (instance) =>
                          new Date(instance.start).toLocaleDateString()
                        )
                      ).map((instancesByDay, index, days) => {
                        return instancesByDay
                          .map((event, index) => {
                            const instanceDate = new Date(
                              event.start
                            ).toLocaleDateString("en-US", {
                              month: "long",
                              day: "numeric",
                            });
                            const eventDate = new Date(
                              instance.start
                            ).toLocaleDateString("en-US", {
                              month: "long",
                              day: "numeric",
                            });
                            const isSameDay = instanceDate === eventDate;

                            if (isSameDay) {
                              if (index === 0) {
                                // If it's the first instance of the day, format the date
                                return `${getTimeNumber(event.start)}`;
                              } else {
                                // If it's not the first instance of the day, format the time of the following instance
                                return `${getTimeNumber(
                                  instancesByDay[index].start
                                )}`;
                              }
                            }
                            return null; // Ignore instances with different dates
                          })
                          .filter(Boolean)
                          .join(" & ");
                      })}
                    </p>
                  )}
                </div>
                {/* Continue with your existing event rendering logic here */}
                <div class="pb-2">
                  {instance.name && (
                    <h3
                      className="text-3xl text-left"
                      style={{
                        fontFamily: "Norwester, Poppins, sans-serif",
                        textTransform: "uppercase",
                        fontStyle: "normal",
                        lineHeight: "1", // Increase the line height (leading)
                      }}
                    >
                      {instance.name}
                    </h3>
                  )}
                </div>
                <div class="pb-2">
                  {instance.attribute_Subtitle && (
                    <div class="text-left text-2xl font-semibold">
                      <h4
                        style={{
                          fontFamily: "Norwester, Poppins, sans-serif",
                          textTransform: "uppercase",
                          fontStyle: "normal",
                          paddingBottom: "3px",
                          margin: "0", // Add margin
                          lineHeight: "1", // Increase the line height (leading)
                        }}
                      >
                        {instance.attribute_Subtitle}
                      </h4>
                    </div>
                  )}
                  {instance.attribute_FeaturedArtists && (
                    <div class="pb-2">
                      <h1 class="text-left" style={{ margin: "0" }}>
                        <p
                          style={{
                            fontFamily: "Montserrat, Poppins, sans-serif",
                            textTransform: "none",
                            fontStyle: "normal",
                            paddingBottom: "3px",
                            margin: "0", // Add margin
                          }}
                        >
                          {instance.attribute_FeaturedArtists}
                        </p>
                      </h1>
                    </div>
                  )}
                  {instance.attribute_SpecialInformation && (
                    <div class="pb-2">
                      <h1 class="text-left" style={{ margin: "0" }}>
                        <p
                          style={{
                            fontFamily: "Montserrat, Poppins, sans-serif",
                            textTransform: "none",
                            fontStyle: "normal",
                            paddingBottom: "3px",
                            margin: "0", // Add margin
                          }}
                        >
                          {instance.attribute_SpecialInformation}
                        </p>
                      </h1>
                    </div>
                  )}
                </div>

                <div className="pb-2">
                  <div className="flex flex-grid grid-cols-3 items-center">
                    {allSoldOut ? (
                      <a
                        href={
                          instance.attribute_FreeEvent
                            ? `/visit/${instance.id
                                .substring(0, 5)
                                .toLowerCase()}/`
                            : `/event/${instance.id
                                .substring(0, 5)
                                .toLowerCase()}/`
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          handleLinkClick(
                            instance.attribute_FreeEvent
                              ? `/visit/${instance.id
                                  .substring(0, 5)
                                  .toLowerCase()}/`
                              : `/event/${instance.id
                                  .substring(0, 5)
                                  .toLowerCase()}/`,
                            instance.start,
                            instance.id,
                            instance.name
                          );
                        }}
                        onContextMenu={(e) => e.preventDefault()} // Disable right-click
                        style={{
                          width: "auto",
                          maxWidth: "100%",
                          fontFamily: "Montserrat, Poppins, sans-serif",
                          textTransform: "uppercase",
                          letterSpacing: "2.5px",
                          fontSize: "1rem",
                          height: "40px",
                          background: "#B00000",
                          border: "none",
                          borderRadius: "none",
                          display: "flex",
                          lineHeight: "1.5rem",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "25px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          color: "white", // Ensure text is visible on dark background
                          textDecoration: "none", // Remove default underline
                        }}
                      >
                        Sold Out
                      </a>
                    ) : (
                      <a
                        href={
                          instance.attribute_FreeEvent
                            ? `/visit/${instance.id
                                .substring(0, 5)
                                .toLowerCase()}/`
                            : `/event/${instance.id
                                .substring(0, 5)
                                .toLowerCase()}/`
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          handleLinkClick(
                            instance.attribute_FreeEvent
                              ? `/visit/${instance.id
                                  .substring(0, 5)
                                  .toLowerCase()}/`
                              : `/event/${instance.id
                                  .substring(0, 5)
                                  .toLowerCase()}/`,
                            instance.start,
                            instance.id,
                            instance.name
                          );
                        }}
                        style={{
                          width: "auto",
                          maxWidth: "100%",
                          fontFamily: "Montserrat, Poppins, sans-serif",
                          textTransform: "uppercase",
                          letterSpacing: "2.5px",
                          fontSize: "1rem",
                          height: "40px",
                          background: "#009ED0",
                          border: "none",
                          borderRadius: "none",
                          display: "flex",
                          lineHeight: "1.5rem",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "25px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          color: "white", // Ensure text is visible on dark background
                          textDecoration: "none", // Remove default underline
                        }}
                      >
                        {instance.attribute_FreeEvent
                          ? "Event Info"
                          : "Buy Tickets"}
                      </a>
                    )}
                    {instance.attribute_FreeEvent ? (
                      <div className="" style={{ flex: "1" }}>
                        {/* Empty div to maintain grid layout */}
                      </div>
                    ) : (
                      <div
                        className="mx-2.5"
                        style={{
                          flex: "1",
                          fontFamily: "Montserrat, sans-serif",
                          textTransform: "none",
                          fontWeight: "normal",
                          display: "flex",
                          alignItems: "center",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {instance.prices
                          ? `$${instance.prices} (+$${instance.commission} fee)`
                          : ""}
                      </div>
                    )}
                  </div>
                </div>

                {instancesOnDayAndEventId.map((event) => (
                  <div class="pb-2">
                    <div className="flex flex-grid grid-cols-3 items-center">
                      {event.availableStatus === 0 && !allSoldOut && (
                        <div>
                          <label
                            style={{
                              width: "auto",
                              maxWidth: "100%",
                              fontFamily: "Montserrat, Poppins, sans-serif",
                              textTransform: "uppercase",
                              fontStyle: "italic",
                              fontSize: ".8rem",
                              height: "30px",
                              background: "#B00000",
                              border: "none",
                              borderRadius: "none",
                              display: "flex",
                              lineHeight: "1.5rem",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "10px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {getTimeNumber(event.start)} is sold out.
                          </label>
                        </div>
                      )}
                      {event.availableStatus > 0 &&
                        event.availableStatus <= 5 &&
                        !allSoldOut && (
                          <div>
                            <label
                              style={{
                                width: "auto",
                                maxWidth: "100%",
                                fontFamily: "Montserrat, Poppins, sans-serif",
                                textTransform: "uppercase",
                                fontStyle: "italic",
                                fontSize: ".8rem",
                                height: "30px",
                                background: "#B00000",
                                border: "none",
                                borderRadius: "none",
                                display: "flex",
                                lineHeight: "1.5rem",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "10px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {getTimeNumber(event.start)} Few Tickets Remain
                            </label>
                          </div>
                        )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </li>
      </div>
    );
  } 

export default Meeting;
